<!-- PANEL TÜRÜ KULLANIM (dışarıdan açılıp kapanan sağ panel) -->
<div
  *ngIf="isExternal"
  class="panel"
  [ngClass]="{ open: openPanel }"
  [ngStyle]="{ '--contact-side-panel-width': width }"
>
  <div class="data-wrapper">
    <ng-container *ngIf="openPanel">
      <div class="header-area">
        <span class="header-text">
            {{title}}
        </span>
        <dx-button
          stylingMode="contained"
          type="danger"
          text="Kapat"
          (click)="closePopup.emit()"
        ></dx-button>
      </div>
      <div class="gis-map-area custom-height">
        <ng-container *ngTemplateOutlet="mapBody"></ng-container>
      </div>
    </ng-container>
  </div>
</div>

<!-- YAN PANEL (sayfa formları): sabitse sayfada, değilse kenardan açılan panelde -->
<ng-container *ngIf="!isExternal && yanPanel">
  <div *ngIf="sabit" class="gis-map-area">
    <div class="yan-baslik">
      <span class="yan-baslik-text"><i class="dx-icon-map"></i> Harita</span>
      <dx-button icon="unpin" stylingMode="text" hint="Sabitlemeyi kaldır (harita kenardan açılsın)" (onClick)="sabitle(false)"></dx-button>
    </div>
    <ng-container *ngTemplateOutlet="mapBody"></ng-container>
  </div>

  <!-- Kenar sekmesi ve kayar panel sayfa köküne taşınır: formun detay panelleri gibi katmanların üstünde kalsın -->
  <div #yanKatman class="yan-katman">
    <div *ngIf="kenarSekmesi" class="yan-sekme" title="Haritayı aç" (click)="panelAc()">
      <i class="dx-icon-map"></i>
      <span>Harita</span>
    </div>

    <div class="panel yan-panel" [ngClass]="{ open: panelAcik }">
      <div class="data-wrapper">
        <ng-container *ngIf="panelAcik">
          <div class="header-area">
            <span class="header-text"><i class="dx-icon-map"></i> Harita</span>
            <span class="yan-panel-butonlar">
              <dx-button icon="pin" stylingMode="text" hint="Sayfaya sabitle" (onClick)="sabitle(true)"></dx-button>
              <dx-button stylingMode="contained" type="danger" text="Kapat" (onClick)="panelKapat()"></dx-button>
            </span>
          </div>
          <div class="gis-map-area custom-height">
            <ng-container *ngTemplateOutlet="mapBody"></ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<!-- POPUP / SAYFA İÇİ KULLANIM -->
<div *ngIf="!isExternal && !yanPanel" class="gis-map-area">
  <ng-container *ngTemplateOutlet="mapBody"></ng-container>
</div>

<ng-template #mapBody>
  <ng-container [ngSwitch]="durum">
    <div *ngSwitchCase="'lisanssiz'" class="gis-map-info-panel">
      <i class="dx-icon-map gis-map-info-icon"></i>
      <div class="gis-map-not-availeable-text">Harita Uygulaması Lisanslanmamış</div>
      <div class="gis-map-info-detail">Bu kurum için tanımlı bir harita (GIS) uygulaması bulunmamaktadır.</div>
    </div>
    <div *ngSwitchCase="'tanimsiz'" class="gis-map-info-panel">
      <i class="dx-icon-map gis-map-info-icon"></i>
      <div class="gis-map-not-availeable-text">Harita hizmeti henüz etkinleştirilmedi.</div>
    </div>
    <ng-container *ngSwitchDefault>
      <!-- Harita iframe'i GisMapService tarafından bu alanın üzerine konumlandırılır. -->
      <div #slot class="frame-area gis-map-slot"></div>
      <div class="gis-map-text">
        <span>{{infoText}}</span>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
